import React from 'react';
import InfiniteScroll from "react-infinite-scroll-component";

export const CommonGrid = ({
                             infiniteScrollProps,
                             tableProps: {
                               getTableProps,
                               getTableBodyProps,
                               headerGroups,
                               rows,
                               prepareRow,
                             },
                             customTableStyles = '',
                             customScrollContainerStyles = '',
                             customScrollContainerID = 'scrollContainer'
                           }) => {

  return (
    <div id={customScrollContainerID} className={customScrollContainerStyles}>
      <InfiniteScroll {...infiniteScrollProps}>
        <table {...getTableProps()}
               className={`table table-head-custom table-vertical-center infinite-scroll-table ${customTableStyles}`}>
          <thead className="sticky-header head custom-thead">
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps()} id='custom-brand-color-tableHead'>{column.render('Header')}</th>
              ))}
            </tr>
          ))}
          </thead>
          <tbody {...getTableBodyProps()} className="body">
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} key={i}>
                {row.cells.map(cell => {
                  return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>;
                })}
              </tr>
            );
          })}
          </tbody>
        </table>
      </InfiniteScroll>
    </div>
  );
};

export default CommonGrid;
